import {FmlxIcon, FmlxTooltip} from 'fmlx-common-ui';
import FastButton from 'components/FastButton';
import PropTypes from 'prop-types';
import FastTextBox from 'components/Inputs/FastTextBox';
import {Size, TextBoxMode} from 'constants/UIComponentEnum';
import './PipettingProfileInputType.scss';
import {parseMessage} from 'lib/stringHelper';
import FastSwitch from 'components/Switch/FastSwitch';

function NumericTextBox({onChange, tooltipLabel, increment, precision, ...props}) {
  return (
    <div className="pipetting-profile-type__numeric-textbox" onMouseDown={(e) => e.stopPropagation()}>
      <FmlxTooltip title={tooltipLabel}>
        <span>
          <FastTextBox
            size={Size.SM}
            mode={TextBoxMode.NUMBER}
            increment={increment}
            precision={precision}
            preventScroll
            hidesArrowButton
            useOutsideArrowButton
            // eslint-disable-next-line react/jsx-props-no-spreading
            {...props}
            onChange={null}
            onBlur={onChange}
          />
        </span>
      </FmlxTooltip>
    </div>
  );
}

NumericTextBox.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.any.isRequired,
  tooltipLabel: PropTypes.string,
  increment: PropTypes.number,
  precision: PropTypes.number,
};

NumericTextBox.defaultProps = {
  tooltipLabel: '',
  increment: 0.1,
  precision: 2,
};

function Switch({...props}) {
  return (
    <div
      className="pipetting-profile-type__switch"
      onClick={(e) => {
        e.stopPropagation();
      }}
    >
      {/* eslint-disable-next-line react/jsx-props-no-spreading */}
      <FastSwitch size="xxs" {...props} />
    </div>
  );
}

function Button({...props}) {
  return (
    <div
      className="pipetting-profile-type__button"
      onClick={(e) => {
        e.stopPropagation();
      }}
    >
      {/* eslint-disable-next-line react/jsx-props-no-spreading */}
      <FastButton size={Size.SM} {...props} />
    </div>
  );
}

function InfoTooltip({tooltipLabel}) {
  return (
    <div className="pipetting-profile-type__tooltip">
      <FmlxTooltip title={tooltipLabel}>
        <span>
          <FmlxIcon name="Info" size={Size.SM} />
        </span>
      </FmlxTooltip>
    </div>
  );
}

InfoTooltip.propTypes = {tooltipLabel: PropTypes.string.isRequired};

function UnitWrapper({style, children}) {
  return (
    <p style={style} className="pipetting-profile-type__unit">
      {children}
    </p>
  );
}
UnitWrapper.propTypes = {style: PropTypes.object, children: PropTypes.any.isRequired};
UnitWrapper.defaultProps = {style: {}};

function PipettingProfileInputType() {
  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <></>;
}

PipettingProfileInputType.NumericTextBox = NumericTextBox;
PipettingProfileInputType.Switch = Switch;
PipettingProfileInputType.Button = Button;
PipettingProfileInputType.InfoTooltip = InfoTooltip;
PipettingProfileInputType.Unit = {
  MicroLiterPerSec: () => (
    <UnitWrapper>{parseMessage('protocolEditor.taskList.pipettingProfile.unit.microLiterPerSec')}</UnitWrapper>
  ),
  MillimeterPerSec: () => (
    <UnitWrapper>{parseMessage('protocolEditor.taskList.pipettingProfile.unit.mmPerSec')}</UnitWrapper>
  ),
  MillimeterAboveBottomWell: () => (
    <UnitWrapper style={{fontSize: '8px'}}>
      {parseMessage('protocolEditor.taskList.pipettingProfile.unit.mmAboveBottomOfWell')}
    </UnitWrapper>
  ),
  MillimeterFromCenterWell: () => (
    <UnitWrapper style={{fontSize: '8px'}}>
      {parseMessage('protocolEditor.taskList.pipettingProfile.unit.mmFromCenterOfWell')}
    </UnitWrapper>
  ),
  MillimeterFromSideWell: () => (
    <UnitWrapper style={{fontSize: '8px'}}>
      {parseMessage('protocolEditor.taskList.pipettingProfile.unit.mmFromSideOfWell')}
    </UnitWrapper>
  ),
  SecondAfterTouch: () => (
    <UnitWrapper>{parseMessage('protocolEditor.taskList.pipettingProfile.unit.secAfterTouch')}</UnitWrapper>
  ),
  Times: () => <UnitWrapper>{parseMessage('protocolEditor.taskList.pipettingProfile.unit.times')}</UnitWrapper>,
};

export default PipettingProfileInputType;
